import { withJsonFormsControlProps } from "@jsonforms/react";
import NumberInputField from "./NumberInputField";

export const NumberInputComponent = (props) => {
  const {
    handleChange,
    label,
    data,
    path,
    errors,
    schema,
    uischema,
    required,
    enabled,
  } = props;
  return (
    <NumberInputField
      value={data}
      disabled={!enabled}
      label={uischema.showLabel === false ? "" : label}
      updateValue={(newVal) => {
        const parsedValue = parseInt(newVal, 10);
        handleChange(path, Number.isNaN(parsedValue) ? undefined : parsedValue);
      }}
      errors={errors}
      schema={schema}
      uiSchema={uischema}
      required={required}
    />
  );
};

export const NumberInputControl = withJsonFormsControlProps(NumberInputComponent);
